import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/PopularStores.css';

const popularStores = [
  { name: "Nykaa", image: "nykaa.png" },
  { name: "Air India", image: "airindia.png" },
  { name: "Dell", image: "dell.png" },
  { name: "AJIO", image: "ajio.png" },
  { name: "Myntra", image: "myntra.png" },
  { name: "Uber", image: "uber.png" },
  { name: "Amazon", image: "amazon.png" },
  { name: "MakeMyTrip", image: "makemytrip.png" },
  { name: "Udemy", image: "udemy.png" },
  { name: "BigRock", image: "bigrock.png" },
  { name: "Samsung", image: "samsung.png" },
  { name: "Flipkart", image: "flipkart.png" }
];

const PopularStores = () => {
  const navigate = useNavigate();

  const handleStoreClick = (storeName) => {
    const slug = storeName.toLowerCase().replace(/\s+/g, '-');
    navigate(`/store/${slug}`);
  };

  return (
    <div className="popular-stores-section">
      <h2>Popular Stores</h2>
      <div className="popular-stores-container">
        <div className="popular-featured-store">
          <p className="popular-featured-title">Featured Store Of The Month</p>
          <img src={require('../assets/ultahost.png')} alt="Ultahost" />
          <div className="popular-store-meta">
            <span>5 Coupons | 11 Offers Available</span>
          </div>
        </div>

        <div className="popular-stores-grid">
          {popularStores.map((store, index) => (
            <div 
              className="popular-store-card" 
              key={index} 
              onClick={() => handleStoreClick(store.name)}
              style={{ cursor: 'pointer' }}
            >
              <img src={require(`../assets/${store.image}`)} alt={store.name} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PopularStores;
